<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" class="diglog-card " :title="$t('merchantAccount.top_up')" :close-on-click-modal="false" :width="activeStep === 1 ? '660px' :'1100px'" @close="closeInitData">
      <div class="data-balance-rechange">
        <div v-show="activeStep === 1">
          <div class="section-title">
            {{ $t('data.recharge_step_1_title') }}

          </div>
          <div class="section-tip" style="margin-top: 5px">
            {{ $t('data.recharge_tip') }}
            <div class="line-bottom-1px" />
          </div>
          <div class="select-bank">
            <div class="bank-container">
              <span v-for="(item,index) in bankList" :key="index" :class="{bank:true,active: activeIndex === index}" @click="onClickBank(index)">{{ item.bank }}</span>
            </div>
          </div>

          <div class="content mt-12">
            <div>
              <div class="flex-justify-between mb-12">
                <span class="bank-label">{{ $t('merchant.account_name') }}</span>
                <span class="bank-info">{{ showBankInfo.bank_account_name | cryptoJSAesDecrypt }}</span>
              </div>

              <div class="flex-justify-between mb-12">
                <span class="bank-label">{{ $t('merchant.account_bank') }}</span>
                <span class="bank-info">{{ showBankInfo.bank_full_name }}</span>
              </div>

              <div class="flex-justify-between mb-12">
                <span class="bank-label">{{ $t('merchant.account_num') }}</span>
                <span class="bank-info">{{ showBankInfo.bank_account | cryptoJSAesDecrypt }}</span>
              </div>

              <div class="flex-justify-between mb-12">
                <span class="bank-label">{{ $t('merchant.account_address') }}</span>
                <span class="bank-info">{{ showBankInfo.bank_address }}</span>
              </div>

              <div class="flex-justify-between mb-12 ">
                <span class="bank-label">{{ $t('merchant.company_address') }}</span>
                <span v-if="$store.getters.curCountry.country_code === 'PH'" class="bank-info">Unit 905, One Global Place, 5th Avenue corner 25th Street, Bonifacio Global City, Fort Bonifacio, Taguig City</span>
                <span v-else class="bank-info">-</span>
              </div>

            </div>

            <div slot="footer" class="dialog-footer">
              <el-button type="info" :disabled="submiting || !showBankInfo.id" style="width: 100%;" class="btn-footer" @click="activeStep = 2">{{ $t('components.next') }}</el-button>
            </div>
          </div>
        </div>
        <div v-if="activeStep === 2" class="step-2-container">

          <div class="step-2-container-left">
            <div class="step-2-detail">
              <div class="section-title">
                {{ $t('data.bank_details') }}
              </div>
              <div class="section-tip" style="margin-top: 5px">
                {{ $t('data.recharge_tip') }}
                <div class="line-bottom-1px" />
              </div>
              <div class="flex-justify-between mb-12">
                <span class="bank-label">{{ $t('merchant.account_name') }}</span>
                <span class="bank-info">{{ showBankInfo.bank_account_name | cryptoJSAesDecrypt }}</span>
              </div>

              <div class="flex-justify-between mb-12">
                <span class="bank-label">{{ $t('merchant.account_bank') }}</span>
                <span class="bank-info">{{ showBankInfo.bank_full_name }}</span>
              </div>

              <div class="flex-justify-between mb-12">
                <span class="bank-label">{{ $t('merchant.account_num') }}</span>
                <span class="bank-info">{{ showBankInfo.bank_account | cryptoJSAesDecrypt }}</span>
              </div>

              <div class="flex-justify-between mb-12">
                <span class="bank-label">{{ $t('merchant.account_address') }}</span>
                <span class="bank-info">{{ showBankInfo.bank_address }}</span>
              </div>

              <div class="flex-justify-between mb-12 ">
                <span class="bank-label">{{ $t('merchant.company_address') }}</span>
                <span v-if="$store.getters.curCountry.country_code === 'PH'" class="bank-info">Unit 905, One Global Place, 5th Avenue corner 25th Street, Bonifacio Global City, Fort Bonifacio, Taguig City</span>
                <span v-else class="bank-info">-</span>
              </div>

            </div>

          </div>
          <div class="step-2-container-right">
            <div class="section-title">
              {{ $t('data.recharge_step_2_title') }}
            </div>
            <div class="section-tip" style="margin-top: 5px">
              {{ $t('data.recharge_tip') }}
              <div class="line-bottom-1px" />
            </div>
            <el-form ref="rechargeForm" label-position="left" :model="rechargeForm" status-icon label-width="170px">
              <el-form-item
                :label="$t('data.payment_type')+':'"
                prop="top_up_type"
                :rules="[
                  { required: true, message: 'Payment Type cannot be empty', trigger: ['blur', 'change']}
                ]"
              >
                <el-select v-model="rechargeForm.top_up_type" placeholder="Select Payment Type" style="width: 100%;">
                  <el-option :label="$t('data.online_banking') " :value="1" />
                  <el-option :label="$t('data.offline_check') " :value="2" />
                  <el-option :label="$t('data.offline_cash') " :value="3" />
                </el-select>
              </el-form-item>
              <el-form-item
                :label="$t('data.payment_account')+':'"
                prop="bank_no"
                :rules="[
                  { required: true, message: 'Payment Account cannot be empty', trigger: 'blur'}
                ]"
              >
                <template slot="label">
                  <span>{{ $t('data.payment_account') }} </span>
                </template>
                <el-select
                  v-model="rechargeForm.bank_no"
                  style="width: 100%;"
                  clearable
                  placeholder="Select Payment Account"
                >
                  <el-option

                    v-for="(item,index) in merchantInfo"
                    :key="index"
                    :label="item.settlement_bank + '-' + item.settlement_bank_account_num"
                    :value="item.bank_no"
                  />
                </el-select>
                <br>
                <span v-if="accountList.length === 0" style="color: #71110e;font-size: 12px;">
                  {{ $t('tips.not_bank_account') }}
                </span>
                <span v-if="accountList.length === 0" style="color: #3855f1;cursor: pointer;font-size: 12px;padding-left: 10px;" @click="$router.push({name:'Financial_Manage_Setting'})">Go to Add</span>
              </el-form-item>
              <el-form-item
                :label="$t('components.amount')+':'"
                prop="amount"
                :rules="[
                  { required: true, message: 'Amount cannot be empty', trigger: 'blur'},
                  { validator: checkAmount, trigger: 'blur' }
                ]"
              >
                <el-input v-model="rechargeForm.amount" type="text" placeholder="Enter amount" autocomplete="off"><template slot="prepend">{{ $store.getters.currency }} </template></el-input>
              </el-form-item>

              <el-form-item

                :label="$t('merchantAccount.money_source')+':'"
                prop="money_source"
                :rules="[
                  { required: true, message: 'Source of Funds cannot be empty', trigger: 'blur'},
                ]"
              >
                <el-select v-model="rechargeForm.money_source" placeholder="Select Source of Funds" style="width: 100%;" clearable>
                  <el-option
                    v-for="(item,index) in fundsSourceMap"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <br>
                <el-input v-show="rechargeForm.money_source === 99" v-model="rechargeForm.money_source_defined" :placeholder="$t('map.funds_source_99')" type="text" autocomplete="off" clearable />
              </el-form-item>
              <el-form-item
                :label="$t('data.remark')+':'"
              >
                <el-input
                  v-model="rechargeForm.remark"
                  type="textarea"
                  :rows="3"
                  maxlength="250"
                  placeholder="Enter message or remarks"
                />
              </el-form-item>

              <template>

                <div class="section-title mt-24">
                  {{ $t('data.upload_receipt_required') }}
                </div>
                <div class="section-tip" style="margin-top: 5px">
                  {{ $t('data.upload_receipt_tip') }}
                  <div class="line-bottom-1px" />
                </div>
                <div>

                  <UploadFile
                    :accept-type="'.jpg,.png,.jpeg,.webp,.JPG,.PNG,.JPEG,.WEBP'"
                    :limit-num="5"
                    :list="urlList"
                    type="recharge"
                    @templateFileSuccess="templateFileSuccess"
                    v-on="$listeners"
                  />
                  <!-- <div>
            <el-image
              v-for="item in urlList"
              :key="item.absolutePath"
              :src="item.absolutePath"
              style="width:200px"
              :preview-src-list="urlList.map(i => i.absolutePath)"></el-image>
          </div> -->
                  <div v-for="(item) in urlList" :key="item.name" style="margin-bottom: 10px">
                    <span class="content-file" @click="onClickFileName(item.relativePath)">{{ item.fileName }}</span>
                    <el-button type="danger" size="mini" style="margin-left: 10px" icon="el-icon-delete" @click="onClickRemoveBtn(item)">{{ $t('components.delete') }}</el-button>
                  </div>
                </div>
              </template>
            </el-form>
            <div slot="footer" class="dialog-footer-step-2">
              <el-button type="info" plain :disabled="submiting" class="btn-footer" @click="activeStep = 1">{{ $t('components.previous') }}</el-button>
              <el-button type="info" :disabled="submiting" class="btn-footer" @click="onClickSubmitBtn('form')">{{ $t('components.submit') }}</el-button>
            </div>
          </div>

        </div>
      </div>

    </el-dialog>
    <el-dialog :visible.sync="dialogImageVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
    <RechargeSuccessModal ref="rechargeSuccessModal" @closeModal="closeModal" />
  </div>
</template>
<script>
import { mchRecharge, fetchBankList, GetRechargeInfo, fetchMerchantInfo, bankQueryList } from '@/api/merchant-manage/merchant-manage.js'
import { fetchRelativePath } from '@/api/components/upload.js'
import RechargeSuccessModal from './RechargeSuccessModal.vue'
import { fundsSourceMap } from '@/utils/maps'

export default {
  name: 'Balance_Rechange',
  components: {
    RechargeSuccessModal,
    UploadFile: () => import('@/views/components/Upload/UploadFileBtn.vue')
  },
  props: {
    balance: {
      type: Number,
      default: 0
    }
  },
  data() {
    this.checkAmount = (rule, value, callback) => {
      value = Number(value)
      this.$commonFn.validateFormAmount({ rule, value, callback })
      callback()
    }
    return {
      submiting: false,
      bankList: [],
      accountList: [],
      urlList: [],
      activeStep: 1,
      activeIndex: 0,
      showBankInfo: {},
      rechargeForm: { amount: '' },
      dialogVisible: false,
      dialogImageUrl: '',
      merchantInfo: {},
      dialogImageVisible: false,
      looking: false,
      editData: {}
    }
  },
  computed: {
    fundsSourceMap() {
      return fundsSourceMap()
    }
  },
  created() {

  },
  methods: {
    closeInitData() {
      this.activeStep = 1
      this.activeIndex = 0
      this.rechargeForm = {}
      this.urlList = []
    },
    showModal(data) {
      this.dialogVisible = true
      this.initData()
      this.getMerchantInfo()
      this.getBankQueryList()
      if (data) {
        this.editData = data
      } else {
        this.editData = {}
      }
    },
    initData() {
      Promise.all([fetchBankList(), bankQueryList({ audit_status: 2 })]).then(res => {
        const [sysBankData, mchBankData] = res
        const sysData = sysBankData.data
        this.bankList = sysData
        this.showBankInfo = JSON.parse(JSON.stringify(sysData[0]))

        const mchData = mchBankData.data || []
        this.accountList = mchData.filter(i => i.audit_status === 2)
        // 默认第一个
        // this.rechargeForm.bank_no = this.accountList[0] && this.accountList[0].bank_no
        this.getRechargeInfo()
      })
    },
    getMerchantInfo() {
      fetchMerchantInfo().then(res => {
        // const { merchant = {}, balance } = res.data
        // const { merchant_basic_info, withdraw_fee_status } = merchant
        this.balanceInfo = res.data.balance || {}
        // this.merchantInfo = { ...merchant_basic_info, withdraw_fee_status }
      })
    },
    getBankQueryList() {
      // let settlement_type = 1
      // if (this.$store.getters.curCountry.country_code === 'HK-USD') {
      //   settlement_type = 2
      // }
      bankQueryList({ audit_status: 2, use_status: 1 }).then(res => {
        this.merchantInfo = res.data.filter(i => i.audit_status === 2)
      })
    },
    getRechargeInfo() {
      const id = this.editData.id
      if (id) {
        GetRechargeInfo({ id }).then(res => {
          const rechargeInfo = res.data
          const { issuing_bank_account_num, sys_bank_id } = rechargeInfo
          const curRechargeBank = this.accountList.find(item => item.settlement_bank_account_num === issuing_bank_account_num)
          if (curRechargeBank) {
            rechargeInfo.bank_no = curRechargeBank.bank_no
          }
          const item = this.bankList.find(i => i.id === sys_bank_id)
          const index = this.bankList.findIndex(i => i.id === sys_bank_id)
          this.showBankInfo = item || {}
          this.activeIndex = index
          this.activeStep = 2
          rechargeInfo.amount = rechargeInfo.amount / 100
          this.rechargeForm = rechargeInfo
          this.urlList = rechargeInfo.voucher_url.map((i, index) => ({
            absolutePath: rechargeInfo.voucher_url_oss_url[index],
            relativePath: i,
            fileName: i.replace(/^(file\/)/, '')
          }))
        })
      }
    },
    onClickFileName(url) {
      if (this.looking) {
        return
      }
      this.looking = true
      fetchRelativePath({ filename: url }).then(res => {
        this.doFileView(res.data)
      }).finally(() => {
        this.looking = false
      })
    },
    doFileView(relativePath) {
      if (!/\.(pdf|PDF)/.test(relativePath)) {
        if (/\.(gif|jpg|jpeg|png|GIF|JPG|PNG)/.test(relativePath)) {
          this.dialogImageVisible = true
          this.dialogImageUrl = relativePath
          return
        }
        const url = encodeURIComponent(relativePath)
        window.open(
          'https://view.officeapps.live.com/op/view.aspx?src=' + url,
          '_blank'
        )
        return false
      } else {
        window.open(relativePath, '_blank')
      }
    },
    onClickRemoveBtn(item) {
      this.urlList = this.urlList.filter(i => i.relativePath !== item.relativePath)
    },
    templateFileSuccess(data) {
      this.urlList.push(data)
    },
    changeStepStatus(num) {
      this.activeStep = num
    },
    changModalStatus(value) {
      this.dialogVisible = value
    },
    onClickBank(index) {
      this.activeIndex = index
      this.showBankInfo = this.bankList[index]
    },
    onClickSubmitBtn() {
      this.$refs.rechargeForm.validate((valid) => {
        if (valid) {
          if (!this.urlList.length) return this.$message.warning('Please upload at least one image!')
          this.submiting = true
          const params = {
            amount: this.$commonFn.mathMultiply(Number(this.rechargeForm.amount), 100),
            sys_bank_id: this.showBankInfo.id,
            bank_no: this.rechargeForm.bank_no,
            top_up_type: this.rechargeForm.top_up_type,
            remark: this.rechargeForm.remark,
            voucher_url: this.urlList.map(i => i.relativePath),
            id: this.rechargeForm.id,
            money_source: this.rechargeForm.money_source,
            money_source_defined: this.rechargeForm.money_source_defined
          }
          const obj = JSON.parse(JSON.stringify(params))
          mchRecharge(params).then(res => {
            this.changModalStatus(false)
            setTimeout(() => {
              this.$refs.rechargeSuccessModal.changModalStatus(true, obj.amount / 100)
            }, 500)
            this.$emit('get-merchant-info')
            this.rechargeForm.amount = ''
          }).finally(() => {
            this.submiting = false
          })
        } else {
          this.$message.warning('Please check if any required fields are not filled!')
        }
      })
    },
    closeModal() {
      this.$router.push({ name: 'Financial_Manage_Balance', params: { activeName: 'Recharge_Record' }})
    },
    onClickFistBread(name) {
      this.$router.push({ name })
    }
  }
}
</script>

<style lang="scss" scoped>
.divider {
  background: #D3D7DF;
}
.step-2-container{
  display: flex;
}
.step-2-container-left{
  margin-right: 24px;
  width: 510px;
  .step-2-detail{
    padding: 24px;
    background: #EDF2F9;
  }
}
.step-2-container-right{
  flex: 1;
}
.bank-label{
    width: 210px;
    font-size: 14px;
    color: #364250;
    font-weight: 500;  font-family: 'Poppins-Medium';
}
.bank-info{
  flex: 1;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.2;
  color: #488CE8;
}
.data-balance-rechange{
  .select-bank{
    .bank{
      display: inline-block;
      margin-right: 12px;
      margin-bottom: 12px;
      padding: 12px 30px;
      font-size: 14px;
      text-align: center;
      font-weight: 600;
      border-radius: 4px;
      color: #488CE8;
      border: 1px solid #488CE8;
      background: #FFF;
      cursor: pointer;
      &.active{
        color: #0058CF;
        background: rgba(72, 140, 232, 0.20);
        border: 1px solid rgba(72, 140, 232, 0.20);

      }
    }
  }
  .input-item{
    width: 364px;
  }
  .tip-enter{
    margin-bottom: 24px;
    font-weight: 400;
    font-size: 14px;
    color: #7A869E;
  }
  .info{
    margin-top: 32px;
    margin-bottom: 16px;
    font-weight: 500;  font-family: 'Poppins-Medium';
    font-size: 18px;
    color: #3855F1;
  }
  .tip{
    margin-bottom: 32px;
    font-weight: 400;
    font-size: 14px;
    color: #7A869E;
  }

 .dialog-footer{
    padding-top: 18px;
    .btn-footer{
      height: 40px;
      font-size: 12px;
      border-radius: 4px;
      &:hover{
        opacity: .9;
      }
    }

  }
  .dialog-footer-step-2{
    text-align: right;
    margin-top: 48px;
    .btn-footer{
      width: 170px;
    }
  }
}
.content-file{
  display: inline-block;
  width: 330px;
  vertical-align: middle;
  color:#3855F1;
  text-decoration: underline;
  cursor: pointer;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}

</style>
